import PasswordSetup from './PasswordSetup';

export default PasswordSetup;
